export default function assertType<T>(_value: unknown): asserts _value is T {}
